// extracted by mini-css-extract-plugin
export default {"contactspage":"contactspage_contactspage__NBW0g","pageContainer":"contactspage_pageContainer__p+Z9H"};